module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFAAAAA1BAMAAAAkBnF3AAAAD1BMVEX///8AJlTOESbeYG5Wb42QNrxKAAAAJ0lEQVRIx2MQRAYODEiAWQkZMIwqHFU4qnBU4ajCUYWjCkcVUkEhAIQklyN0REMMAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/careers/flags/fr.png
// module id = q4Jm
// module chunks = 2